import { createApp } from '@app/adapters/create-app'

import UserManagementTabs from '@app/application/user-management/components/user-management-tabs.vue'

window.onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='user-management-tabs']").each(function () {
    createApp(UserManagementTabs, {
      tabs: JSON.parse(this.dataset.tabs || '[]'),
    }).mount(this)
  })
})
